import { ClassicForm } from "@/pages/classic-form";
import { registerAttach } from "./lib/registerAttach.browser";

registerAttach(ClassicForm, "classic");
